import classNames from 'classnames';

import Layout from '../Layout';

import styles from './_index.module.scss';

export interface MaintenanceViewProps extends React.HTMLAttributes<HTMLDivElement> {
  heading: string;
  logo?: React.ReactNode;
}

const MaintenanceView = ({ className, heading, logo }: MaintenanceViewProps) => {
  return (
    <Layout.Flex.Column className={classNames(styles['maintenance-view'], className)}>
      {logo && <div className={styles['maintenance-view-logo']}>{logo}</div>}
      <h2>{heading}</h2>
    </Layout.Flex.Column>
  );
};

export default MaintenanceView;
